













































import { cloneDeep } from 'lodash-es';
import { defineComponent, toRefs, PropType } from '@vue/composition-api';
import TtamInfiniteScrollContainer from 'src/components/common/infinite-scroll-container/index.vue';
import TtamMaterialLibrary from '../index';
import { MaterialType } from '@tt4b/ttam-enums';

const name = 'ttam-material-library-list';

export default defineComponent({
  name,

  components: {
    TtamInfiniteScrollContainer,
    TtamLibraryListItem: TtamMaterialLibrary.TtamLibraryListItem,
    TtamLibraryListEmpty: TtamMaterialLibrary.TtamLibraryListEmpty,
  },

  // todo spf 简化入参
  props: {
    isLoading: { type: Boolean, default: false },
    list: { type: Array, default: () => [] },
    limit: { type: Number, default: 20 },
    type: { type: String as PropType<MaterialType>, default: MaterialType.Video },
    selectedIds: { type: Array as PropType<number[]>, default: () => [] },
    isNativeType: {
      type: Boolean,
      default: false,
    },
    isPlayableType: {
      type: Boolean,
      default: false,
    },
    isAco: {
      type: Boolean,
      default: false,
    },
    isAcoWithTtaNativeAds: {
      type: Boolean,
      default: false,
    },
    isAffiliate: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, { emit }) {
    const { isLoading, selectedIds } = toRefs(props);

    function onClickItem(item) {
      const selectedCopy = cloneDeep(selectedIds.value);
      const idx = selectedCopy.indexOf(item.id);
      if (idx > -1) {
        selectedCopy.splice(idx, 1);
      } else {
        selectedCopy.push(item.id);
      }
      emit('change', selectedCopy);
    }

    function onAppend() {
      if (!props.list?.length || isLoading.value) {
        return;
      }
      emit('append');
    }

    return {
      onAppend,
      onClickItem,
    };
  },
});
